import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as AuthActions, Selectors as AuthSelectors } from 'store/ducks/auth';

import { Icon, Dropdown } from 'components';

import LogoSmall from 'assets/images/logo.svg';
import Logo from 'assets/images/logo.svg';

class Topbar extends Component {
  handleLogout = e => {
    e.preventDefault();
    this.props.logoutRequest();
  };

  render() {
    const { user } = this.props;

    return (
      <div className="topbar-main">
        <div className="container-fluid">
          <div className="logo" id="logo-tour">
            <Link to="/admin/dashboard" className="logo">
              <img src={LogoSmall} alt="" height="26" className="logo-small" />
              <img src={Logo} alt="" height="24" className="logo-large" />
            </Link>
          </div>

          {!user.loading && user.data.id && (
            <span className="user-info">
              <span>{user.data.attributes.name}</span>
              <span className="user-separator">|</span>
              <a href="" onClick={this.handleLogout}>
                Sair
              </a>
            </span>
          )}

          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

const mapState = state => ({
  auth: state.auth,
  user: {
    ...state.auth.user,
    data: AuthSelectors.user(state.auth.user.data),
  },
});

const mapActions = dispatch => bindActionCreators(AuthActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Topbar);



// WEBPACK FOOTER //
// ./src/layouts/Default/components/Topbar/index.js